export enum CalAnimation {
  None = 0,
  Fade = 1,
  ScaleTop = 2,
  ScaleCenter = 3,
  Rotate = 4,
  FlipDiagonal = 5,
  Own = 6,
}
